import * as React from 'react'
import {url} from '../../App/AuthenticatedRoute'
import {InquiryDetailsState} from './InquiryDetailsState'
import {InquiryDetailsAction} from './InquiryDetailsActions'
import Tabs from 'material-ui/Tabs/Tabs'
import {MenuAndUpButton} from '../../View/MenuAndUpButton'
import Tab from 'material-ui/Tabs/Tab'
import AppBar from 'material-ui/AppBar'
import {OfferView} from './Offer/OfferView'
import {OverviewView} from './Overview/OverviewView'
import {OrderView} from './Order/OrderView'

export function InquiryDetailsView({state, dispatch}: {
    state: InquiryDetailsState,
    dispatch: (action: InquiryDetailsAction) => void,
}) {
    const {inquiryWithDetails} = state
    return (
        <div className="inquiry">

            <div className="navigation">
                <AppBar
                    style={{boxShadow: 'none'}}
                    title={'Anfrage #' + inquiryWithDetails.inquiry.inquiryNumber}
                    className="navigation__bar"
                    iconElementLeft={
                        <MenuAndUpButton
                            onMenuButtonClicked={() => dispatch({
                                type: 'MenuButtonClicked',
                            })}
                            onUpButtonClicked={
                                event => {
                                    event.preventDefault()
                                    history.back()
                                }
                            }
                            upUrl={url({type: 'InquiryOverview'})}
                        />}
                />
            </div>
            <Tabs
                className="tabs"
                inkBarStyle={{height: '4px', marginTop: '-4px'}}
                tabItemContainerStyle={{
                    boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.12), 0px 1px 4px rgba(0, 0, 0, 0.12)'
                }}
                contentContainerStyle={{
                    padding: '32px'
                }}
                value={state.activeTab}
                onChange={
                    value =>
                        dispatch({
                            type: 'ActiveTabChanged',
                            value,
                        })
                }
            >
                <Tab
                    label="Übersicht"
                    className="tabs__tab"
                    value="overview"
                >
                    <OverviewView
                        dispatch={
                            subAction =>
                                dispatch({
                                    type: 'OverviewTabAction',
                                    subAction: subAction
                                })
                        }
                        state={state.overviewTab}
                    />
                </Tab>
                <Tab
                    label="Angebot"
                    className="tabs__tab"
                    value="offer"
                >
                    <OfferView
                        active={state.activeTab === 'offer'}
                        state={state.offerTab}
                        totals={inquiryWithDetails.totals}
                        isForBalke={inquiryWithDetails.isForBalke}
                        dispatch={
                            subAction =>
                                dispatch({
                                    type: 'OfferTabAction',
                                    subAction: subAction
                                })
                        }
                    />
                </Tab>
                <Tab
                    label="Auftrag"
                    className="tabs__tab"
                    value="order"
                    disabled={inquiryWithDetails.isForBalke}
                >
                    <OrderView
                        active={state.activeTab === 'order'}
                        state={state.orderTab}
                        totals={inquiryWithDetails.totals}
                        dispatch={
                            subAction =>
                                dispatch({
                                    type: 'OrderTabAction',
                                    subAction: subAction
                                })
                        }
                    />
                </Tab>
            </Tabs>
        </div>
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/InquiryDetails/InquiryDetailsView.tsx